<template>
  <div class="Edit-Profile">
    <div class="Header-Edit-Profile">
      <h1>Edit Profile</h1>
    </div>
    <FormEditProfileVue/>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import FormEditProfileVue from './FormEditProfile.vue';
export default {
  computed: {
    ...mapGetters("UserManager", ["getUserLoged"]),
  },
  components:{
    FormEditProfileVue
  },
  data: () => ({
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    company: "",
  }),
  created() {
    let nombreCompleto = this.getUserLoged.name.split(" ");
    if (nombreCompleto.length < 4) {
      this.firstname = nombreCompleto[0];
    } else {
      this.firstname = nombreCompleto[0] + " " + nombreCompleto[1];
    }
    this.lastname =
      nombreCompleto[nombreCompleto.length - 2] +
      " " +
      nombreCompleto[nombreCompleto.length - 1];
    this.email = this.getUserLoged.username
    this.company = this.getUserLoged.companyName
    this.phoneNumber = this.getUserLoged.telephone
  },
};
</script>

<style>
.Edit-Profile {
  margin: 15px auto;
  padding-bottom: 15px;
  border-radius: 10px;
  box-shadow: 0px 3px 30px 0px rgba(0, 0, 0, 0.161);
}
.Edit-Profile .Header-Edit-Profile {
  width: 100%;
  padding: 18px 0 0 0;
}
.Edit-Profile .Header-Edit-Profile h1 {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 1.5rem;
  color: var(--dark-firts-color);
  border-bottom: 1px solid var(--firts-color);
  margin-left: 10px;
  width: fit-content;
  line-height: 20px;
}
</style>